import l10n from '../../../shared/strings';

const MEDIA_ERROR_SUPPRESS_MS = 8000;
let suppressMediaErrorToastsUntil = 0;

/**
 * Briefly skip sticky media-load error toasts after a channel gone notice so they
 * cannot re-queue on top of (or ahead of) the Gone toast.
 */
export const suppressMediaErrorToastsBriefly = (ms = MEDIA_ERROR_SUPPRESS_MS) => {
  suppressMediaErrorToastsUntil = Date.now() + ms;
};

export const shouldSuppressMediaErrorToast = () => (
  Date.now() < suppressMediaErrorToastsUntil
);

const showNeutralChannelGoneToast = ({ Toast, message } = {}) => {
  if (typeof Toast !== 'function') return;

  if (typeof Toast.dismissAll === 'function') {
    Toast.dismissAll();
  }

  suppressMediaErrorToastsBriefly();

  Toast(message, {
    autoClose: 5000,
    closeButton: true,
  });
};

/**
 * Neutral toast when sync-on-read finds the linked Shopify product was deleted
 * and the listing was reverted to local draft.
 */
export const showChannelProductGoneToast = ({ Toast } = {}) => {
  showNeutralChannelGoneToast({
    Toast,
    message: l10n.TOAST.SHOPIFY_PRODUCT_DELETED_SHOWING_DRAFT,
  });
};

/**
 * Neutral toast when sync-on-read finds a linked Shopify variant was deleted
 * and the listing variant was reverted to local draft.
 */
export const showChannelVariantGoneToast = ({ Toast } = {}) => {
  showNeutralChannelGoneToast({
    Toast,
    message: l10n.TOAST.SHOPIFY_VARIANT_DELETED_SHOWING_DRAFT,
  });
};

export const hasChannelProductGoneFlag = (items = []) => (
  (items || []).some((item) => Boolean(item?.channelProductGone))
);

export const hasChannelVariantGoneFlag = (items = []) => (
  (items || []).some((item) => Boolean(item?.channelVariantGone))
);

/**
 * Prefer product-gone toast; otherwise show variant-gone when flagged.
 */
export const showChannelGoneToastFromItems = ({ Toast, items } = {}) => {
  if (hasChannelProductGoneFlag(items)) {
    showChannelProductGoneToast({ Toast });
    return 'product';
  }
  if (hasChannelVariantGoneFlag(items)) {
    showChannelVariantGoneToast({ Toast });
    return 'variant';
  }
  return null;
};
